module.exports = __webpack_public_path__ + "img/portrait-background-remover-after.529047bd.jpg";